import { MRT_Row as MRTRow, MRT_TableInstance as MRTTableInstance } from "material-react-table";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  table: MRTTableInstance<any>;
  row: MRTRow<any>;
  setIsDeleteModalOpen: (o: boolean) => void;
  setDeletionSelected: (s: number[]) => void;
  onEditClick?: (row: MRTRow<any>) => void;
  /** When set, used instead of `setDeletionSelected([row.original.id])` for delete. */
  onRequestDelete?: (row: MRTRow<any>) => void;
  canDelete?: boolean;
};
export const ListRowActions = ({
  title,
  table,
  row,
  setIsDeleteModalOpen,
  setDeletionSelected,
  onEditClick,
  onRequestDelete,
  canDelete = true
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box data-testid={`${title}-list-row-box`} sx={{ display: "flex", gap: "1rem" }}>
      <Tooltip
        data-testid={`${title}-list-row-edit`}
        title={<Typography>{t("Edit")}</Typography>}
        aria-label={"Edit"}
      >
        <IconButton
          data-testid={`${title}-list-row-edit-btn`}
          onClick={() => (onEditClick ? onEditClick(row) : table.setEditingRow(row))}
          size="large"
        >
          <Edit />
        </IconButton>
      </Tooltip>
      {canDelete && (
        <Tooltip
          data-testid={`${title}-list-row-delete`}
          title={<Typography>{t("Delete")}</Typography>}
        >
          <IconButton
            data-testid={`${title}-list-row-delete-btn`}
            onClick={() => {
              setIsDeleteModalOpen(true);
              if (onRequestDelete) {
                onRequestDelete(row);
              } else {
                setDeletionSelected([row.original.id]);
              }
            }}
            size="large"
          >
            <Delete />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
